import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';

const CustomerUrlCell: FC<GridCellProps> = ({ dataItem, colSpan, columnIndex, isSelected, ariaColumnIndex, className, style }) => {
  return (
    <td
      colSpan={colSpan}
      className={className}
      role="gridcell"
      aria-colindex={ariaColumnIndex}
      aria-selected={isSelected}
      data-grid-col-index={columnIndex}
      style={{ ...style, textAlign: 'left' }}
    >
      <a className="text-link" href={`/${dataItem.customerNumber}`}>
        {dataItem.customerName}
      </a>
    </td>
  );
};

export default CustomerUrlCell;
